import axios from "axios";

const RAW_BASE_URL =
  process.env.REACT_APP_API_BASE ||
  process.env.REACT_APP_API_URL ||
  "https://backdanlu.eu-4.evennode.com";

const BASE_URL = String(RAW_BASE_URL).replace(/\/+$/, "");

const PATH = "cuentasgasto";

export const getCuentasGasto = async () => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/${PATH}`;

  try {
    const resp = await axios.get(url, { headers: { token } });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener cuentas de gasto",
    };
  }
};

export const getCuentaGastoById = async (id) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/${PATH}/${id}`;

  try {
    const resp = await axios.get(url, { headers: { token } });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener cuenta de gasto",
    };
  }
};

export const postCuentaGasto = async (data) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/${PATH}`;

  try {
    const resp = await axios.post(url, data, {
      headers: { "Content-Type": "application/json", token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al crear cuenta de gasto",
    };
  }
};

export const putCuentaGasto = async (id, data) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/${PATH}/${id}`;

  try {
    const resp = await axios.put(url, data, {
      headers: { "Content-Type": "application/json", token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al actualizar cuenta de gasto",
    };
  }
};

export const deleteCuentaGasto = async (id) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/${PATH}/${id}`;

  try {
    const resp = await axios.delete(url, { headers: { token } });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al eliminar cuenta de gasto",
    };
  }
};
